import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingsRoutingModule } from './bookings-routing.module';
import { BookingsPageComponent } from './pages/bookings-page/bookings-page.component';
import { SharedModule } from '../shared/shared.module';
import { PrivateBookingModalComponent } from './components/private-booking-modal/private-booking-modal.component';
import { BookingsListComponent } from './components/bookings-list/bookings-list.component';
import { BookingsCalendarViewComponent } from './components/bookings-calendar-view/bookings-calendar-view.component';
import { RoomDetailsModalComponent } from './components/room-details-modal/room-details-modal.component';
import { BookingDetailsModalComponent } from './components/booking-details-modal/booking-details-modal.component';
import { PendingBookingsComponent } from './components/pending-bookings/pending-bookings.component';
import { PublicBookingEditModalComponent } from './components/public-booking-edit-modal/public-booking-edit-modal.component';
import { InvoiceModalComponent } from './components/invoice-modal/invoice-modal.component';
import { BookingsListViewComponent } from './components/bookings-list-view/bookings-list-view.component';
import { PersonalBookingsModalComponent } from './components/personal-bookings-modal/personal-bookings-modal.component';
import { SharedManagerModule } from '../shared-manager/shared-manager.module';
import { BookingCalendarBlockComponent } from './components/booking-calendar-block/booking-calendar-block.component';
import { BookingCalendarRoomComponent } from './components/booking-calendar-room/booking-calendar-room.component';
import { TooltipDirective } from '../shared/directives/tooltip.directive';

@NgModule({
  declarations: [
    BookingsPageComponent,
    PrivateBookingModalComponent,
    BookingsListComponent,
    BookingsCalendarViewComponent,
    RoomDetailsModalComponent,
    BookingDetailsModalComponent,
    PendingBookingsComponent,
    BookingsListViewComponent,
    PublicBookingEditModalComponent,
    InvoiceModalComponent,
    PersonalBookingsModalComponent,
    BookingCalendarBlockComponent,
    BookingCalendarRoomComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedManagerModule,
    BookingsRoutingModule,
    TooltipDirective,
  ],
  exports: [PublicBookingEditModalComponent, RoomDetailsModalComponent],
})
export class BookingsModule {}
